<template>
  <CRow>
    <CCol lg="12">
      <CCard>
          <CCardHeader>
          <strong>Quản lý bảo hành</strong>
          <div class="card-header-actions">
              <CButton type="button" shape="pill" color="info"
              class="ml-1 mr-1"
              @click="exportXls">
                <CIcon name="cil-cloud-download"/>
                Xuất xls</CButton>

            <CButton v-if="allowCreate" type="button" shape="pill" color="info" @click="createNew">
              <CIcon name="cil-plus"/>
              Thêm mới</CButton>
            <CButton type="button" shape="pill" color="secondary"
                     class="ml-1 mr-1"
                     @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="guarantees"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' ', values: ['50', '200', '500']}"
            :items-per-page="100"
            column-filter
            hover
            sorter
            clickable-rows
            pagination
            @row-clicked="editRecord"
            @filtered-items-change="setCurrentItems"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>

            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>
            <template #prod_type="{item}">
              <td class="py-2 text-center">
                {{ prodTypeLabel(item.prod_type) }}
              </td>
            </template>
            <template #quantity="{item}">
              <td class="py-2 text-right">
                {{formatNumber(item.quantity)}}
              </td>
            </template>
            <template #delivered="{item}">
              <td class="py-2 text-right">
                {{formatNumber(item.delivered)}}
              </td>
            </template>
            <template #repairing="{item}">
              <td class="py-2 text-right">
                {{formatNumber(item.repairing)}}
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { prodTypeLabel } from '@/utils/format';

export default {
  data() {
    return {
      allowCreate: true,
      // Define the table fields
      fields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'customer', label: 'Khách hàng' },
        { key: 'project', label: 'Lô sản xuất' },
        { key: 'recv_bill', label: 'Biên bản nhận', _classes: 'font-weight-bold' },
        { key: 'recv_date', label: 'Ngày nhận' , _style:'width:8rem;'},
        // { key: 'send_bill', label: 'Biên bản giao'},
        // { key: 'send_date', label: 'Ngày trả (dự kiến)' },
        { key: 'quantity', label: 'Tổng nhận', _style: 'width:6rem; text-align: center;'},
        { key: 'delivered', label: 'Đã giao', _style: 'width:6rem; text-align: center;' },
        { key: 'repairing', label: 'Còn lại', _style: 'width:6rem; text-align: center;' },
        { key: 'prod_type', label: 'Loại', _style: 'width:5rem; text-align: center;' },
        // { key: 'error', label: 'Lỗi' },
        // { key: 'status', label: 'Tình trạng' },
        // { key: 'updated', label: 'Cập nhật' },
      ],
      // Example data
      guarantees: [],
      withProject: '',
      currentItems: [],
    };
  },
  created() {
    this.withProject = this.$route.query.project;
    this.getAll(this.withProject)
  },
  methods: {
    prodTypeLabel,
    getAll(project) {
      if (project) {
        this.$request(`/api/device/guarantee/project/${project}`).then(res => {
          console.log(res.data)
          this.guarantees = res.data.guarantees
        })
      } else {
        this.$request('/api/device/guarantee').then(res => {
          console.log(res.data)
          this.guarantees = res.data.guarantees
        })
      }
    },
    editRecord(item, index) {
      // console.log('Edit record:', item);
      this.$router.push({
        path: `/device/guaedit`,
        query: {
          id: item.id,
        },
      })
    },
    createNew() {
      this.$router.push({
        path: '/device/guaedit',
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    exportXls() {
      this.$swal.fire({
        title: "Xuất ra tệp excel?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/guaexport`, this.currentItems).
          then(res => {
            if(res.data.status === 'success') {
              this.downloadFile(res.data.filename)
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xuất ra tệp excel",
                html: "lỗi: "+ res.data.status,
              });
            }
          })
        }
      });
    },
    setCurrentItems (val) {
      this.currentItems = val
    },
    downloadFile(fileName) {
      this.$request.get(`/api/repo/downloadbill/${fileName}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
  },
};
</script>
